export * from './dtos';
export * from './crm-find-tariffs.endpoint';
export * from './crm-create-tariff.endpoint';
export * from './crm-patch-tariff.endpoint';
export * from './crm-delete-tariff.endpoint';
